import React, { FC } from 'react';

interface BasketItem {
    ID: number,
    NAME: string,
    QUANTITY: number,
    CHECKED: boolean,
}

type Props = {
    listBasketCurrency: any,
    setListBasketCurrency: any,
    productList: any,
    setProductList: any,
}

const ClaimListProduct: FC<Props> = ({ listBasketCurrency, setListBasketCurrency, productList, setProductList }) => {
    const handleClickOnProductList = (itemId, value, action) => {
        if (action === 'list') {
            let items = productList.filter((item) => item.product === itemId);
            if (items.length > 0) {
                if (value === false) {
                    document.querySelector("#quantity" + itemId).value = 0;

                    let removeIndex = productList.findIndex(obj => obj.product === itemId)
                    productList.splice(removeIndex, 1);

                }
            } else {
                if (value === true) {
                    let quantity = listBasketCurrency.find(obj => obj[0] == itemId)[1].QUANTITY
                    document.querySelector("#quantity" + itemId).value = quantity;
                    productList.push({product: itemId, quantity: quantity})
                    setProductList(productList)
                }
            }
        }

        if (action === 'quantity') {
            let items = productList.filter((item) => item.product === itemId);
            if (items.length > 0) {
                items[0].quantity = value;
            } else {
                productList.push({product: itemId, quantity: value})
                setProductList(productList)
            }
        }
    }

    const setCheckedInCurrentListItems = (itemId, value) => {
        let items = listBasketCurrency.filter((item) => parseInt(item[0]) === itemId);
        items[0][1].CHECKED = !!value;
        setListBasketCurrency([...listBasketCurrency])
    }

    return (
        <div className="flex flex-col md:w-1/2 w-full p-5 pb-0">
            <div className="mb-3">
                <label>
                    <b className="text-hover-red"> *  </b> Проблемные товары
                </label>
                <div className="p-3 dark:bg-grayButton bg-textDark w-full mt-3 rounded-md">
                    <div
                        className="pt-1 flex flex-col items-center w-full h-full md:max-h-[480px] max-h-[300px] overflow-auto">
                        {
                            listBasketCurrency !== undefined ?
                                listBasketCurrency.map((item, k: number) => {
                                    let itemData = item[1] as BasketItem;
                                    return (<div className="w-full flex flex-row mb-2 items-center" key={k}>
                                        <div  className="flex-1 h-full mr-2 flex flex-row justify-between">
                                            <label
                                                className="text-xs font-normal text-dark dark:text-textDarkLightGray">
                                                {itemData.NAME}
                                            </label>
                                        </div>
                                        <div className="w-32 h-full flex flex-row justify-content-end items-center">
                                            <input type="checkbox"
                                                   required
                                                   checked={itemData.CHECKED}
                                                   onChange={(e) => {
                                                       handleClickOnProductList(itemData.ID, e.target.checked, 'list')
                                                       setCheckedInCurrentListItems(itemData.ID, e.target.checked)
                                                   }}
                                                   className="check_input form-check-input p-3.5 mr-3 dark:bg-tagFilterGray
                                                         checked:hover:bg-tagFilterGray border-none dark:border-none
                                                        dark:text-white cursor-pointer font-normal rounded-lg
                                                        text-light-red checked:focus:bg-tagFilterGray "
                                                   placeholder=""/>
                                            <input type="number"
                                                   id={"quantity" + itemData.ID}
                                                   max={itemData.QUANTITY}
                                                   required
                                                   onChange={(e) => {
                                                       if (Number(e.target.value) > itemData.QUANTITY) {
                                                           e.target.value = itemData.QUANTITY;
                                                       }
                                                       handleClickOnProductList(itemData.ID, e.target.value, 'quantity')
                                                   }}
                                                   className={'dark:bg-tagFilterGray bg-white border-none p-1 md:p-2.5 ' +
                                                       ' outline-0 rounded-md w-full focus:outline-0 quantity-prod-claims'}
                                                   placeholder="0"/>
                                            <div className="ms-2 text-base font-normal dark:font-light text-dark whitespace-nowrap
                                            dark:text-textDarkLightGray w-1/6 h-100">
                                                / {itemData.QUANTITY}
                                            </div>
                                        </div>
                                    </div>)
                                })
                                : false
                        }
                    </div>
                </div>
                <p className="text-[10px] mt-2 font-light dark:font-extralight text-dark
                                     dark:text-textDark mb-2">Вы указываете только то количество, с которым возникли
                    проблемы.</p>
                <p className="xl:text-sm text-xs font-medium text-hover-red"> * Обязательные
                    поля</p>
            </div>
        </div>
    )
}

export default ClaimListProduct;